"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomainData = exports.addressesMatch = exports.getOfferSignatureDigestHash = exports.recoverSignerOfOffchainOffer = exports.offchainOfferIsValid = exports.getOffchainOfferType = exports.signOffchainOffer = exports.OfferType = void 0;
const ethers_1 = require("ethers");
var OfferType;
(function (OfferType) {
    OfferType[OfferType["BorrowerSigned"] = 0] = "BorrowerSigned";
    OfferType[OfferType["LenderSigned"] = 1] = "LenderSigned";
    OfferType[OfferType["DualSigned"] = 2] = "DualSigned";
    OfferType[OfferType["Invalid"] = 3] = "Invalid";
})(OfferType = exports.OfferType || (exports.OfferType = {}));
/**
 * Signs an offchain offer.
 * @param config - The config to use for signing the offchain offer.
 * @returns The signature of the offchain offer data.
 */
function signOffchainOffer(config) {
    return __awaiter(this, void 0, void 0, function* () {
        const signer = "provider" in config
            ? //@ts-expect-error  get signer type does not exist but function does
                yield config.provider.getSigner()
            : config.signer;
        const { domain, types, values } = getTypedData(config.submitBidArgs, config.basicOrderParams, config.domainData);
        //@ts-expect-error   _signTypedData type does not exist but function does
        const sig = yield signer._signTypedData(domain, types, values);
        return sig;
    });
}
exports.signOffchainOffer = signOffchainOffer;
function getTypedData(submitBidArgs, basicOrderParams, domainData) {
    const domain = domainData;
    const types = {
        inputs: [
            { name: "offerToken", type: "address" },
            { name: "offerIdentifier", type: "uint256" },
            { name: "offerAmount", type: "uint256" },
            { name: "totalPurchasePrice", type: "uint256" },
            { name: "considerationToken", type: "address" },
            { name: "principal", type: "uint256" },
            { name: "downPayment", type: "uint256" },
            { name: "duration", type: "uint32" },
            { name: "interestRate", type: "uint16" },
            { name: "signatureExpiration", type: "uint32" },
            { name: "marketId", type: "uint256" }
        ],
    };
    const values = {
        offerToken: basicOrderParams.offerToken,
        offerIdentifier: basicOrderParams.offerIdentifier,
        offerAmount: basicOrderParams.offerAmount,
        totalPurchasePrice: submitBidArgs.totalPurchasePrice,
        considerationToken: basicOrderParams.considerationToken,
        principal: submitBidArgs.principal,
        downPayment: submitBidArgs.downPayment,
        duration: submitBidArgs.duration,
        interestRate: submitBidArgs.interestRate,
        signatureExpiration: submitBidArgs.signatureExpiration,
        marketId: submitBidArgs.marketId
    };
    return { domain, types, values };
}
function getOffchainOfferType(offchainOffer) {
    const borrower = offchainOffer.submitBidArgs.borrower;
    const lender = offchainOffer.submitBidArgs.lender;
    if (typeof borrower != "undefined" && typeof lender != "undefined") {
        return OfferType.DualSigned;
    }
    if (typeof lender != "undefined") {
        return OfferType.LenderSigned;
    }
    if (typeof borrower != "undefined") {
        return OfferType.BorrowerSigned;
    }
    return OfferType.Invalid;
}
exports.getOffchainOfferType = getOffchainOfferType;
/**
 * Validates an offchain offer's data.
 */
function offchainOfferIsValid(offchainOffer) {
    const borrower = offchainOffer.submitBidArgs.borrower;
    const lender = offchainOffer.submitBidArgs.lender;
    if (!borrower && !lender) {
        return {
            success: false,
            error: "order must specify either a borrower or lender",
        };
    }
    if (borrower) {
        const recoveredSigner = recoverSignerOfOffchainOffer(offchainOffer.submitBidArgs, offchainOffer.basicOrderParams, offchainOffer.domainData, offchainOffer.borrowerSignature);
        if (!recoveredSigner)
            return { success: false, error: "could not recover borrower signer" };
        const borrowerSignatureIsValid = addressesMatch(borrower, recoveredSigner);
        if (!borrowerSignatureIsValid)
            return { success: false, error: "borrower signature invalid" };
    }
    if (lender) {
        const recoveredSigner = recoverSignerOfOffchainOffer(offchainOffer.submitBidArgs, offchainOffer.basicOrderParams, offchainOffer.domainData, offchainOffer.lenderSignature);
        if (!recoveredSigner)
            return { success: false, error: "could not recover lender signer" };
        const lenderSignatureIsValid = addressesMatch(lender, recoveredSigner);
        if (!lenderSignatureIsValid)
            return { success: false, error: "lender signature invalid" };
    }
    return { success: true, data: offchainOffer };
}
exports.offchainOfferIsValid = offchainOfferIsValid;
/**
 * Recovers the public address of an offchain offer signature.
 * @return The public address of the signer, or undefined if there is no signature.
 */
function recoverSignerOfOffchainOffer(submitBidArgs, basicOrderParams, domainData, signature) {
    if (!signature) {
        return undefined;
    }
    const { domain, types, values } = getTypedData(submitBidArgs, basicOrderParams, domainData);
    const recoveredAddress = ethers_1.utils.verifyTypedData(domain, types, values, signature);
    return recoveredAddress;
}
exports.recoverSignerOfOffchainOffer = recoverSignerOfOffchainOffer;
function getOfferSignatureDigestHash(submitBidArgs, basicOrderParams, domainData) {
    const parsedDomainData = JSON.parse(JSON.stringify({
        name: domainData.name,
        version: domainData.version,
        chainId: domainData.chainId,
        verifyingContract: domainData.verifyingContract
    }));
    const { types, values } = getTypedData(submitBidArgs, basicOrderParams, parsedDomainData);
    const encoder = ethers_1.utils._TypedDataEncoder;
    const codedMessage = encoder.encode(parsedDomainData, types, values);
    const codedHash = encoder.hash(parsedDomainData, types, values);
    const digest = ethers_1.utils.keccak256(codedMessage);
    if (digest != codedHash) {
        throw new Error("Digest mismatch");
    }
    return digest;
}
exports.getOfferSignatureDigestHash = getOfferSignatureDigestHash;
function addressesMatch(addr1, addr2) {
    if (!ethers_1.utils.isAddress(addr1) || !ethers_1.utils.isAddress(addr2))
        return false;
    return ethers_1.utils.getAddress(addr1) == ethers_1.utils.getAddress(addr2);
}
exports.addressesMatch = addressesMatch;
/*
CONTRACT NAME 'Teller_BNPL_Market'
CONTRACT VERSION '3.4'

*/
function getDomainData(contractName, versionString, chainId, verifyingContractAddress) {
    const abiCoder = new ethers_1.utils.AbiCoder();
    const domainString = ethers_1.utils.keccak256(ethers_1.utils.toUtf8Bytes("EIP712Domain(string name,string version,uint256 chainId,address verifyingContract)"));
    const domainData = {
        name: contractName,
        version: versionString,
        chainId,
        verifyingContract: verifyingContractAddress, //networkConfig.bnplContractImplementationAddressV3,
    };
    const domainSeparator = ethers_1.utils.keccak256(abiCoder.encode(["bytes32", "bytes32", "bytes32", "uint256", "address"], [
        domainString,
        ethers_1.utils.keccak256(ethers_1.utils.toUtf8Bytes(domainData.name)),
        ethers_1.utils.keccak256(ethers_1.utils.toUtf8Bytes(domainData.version)),
        domainData.chainId,
        domainData.verifyingContract,
    ]));
    const TypedDataEncoder = ethers_1.utils._TypedDataEncoder;
    const hashDomain = TypedDataEncoder.hashDomain(domainData);
    if (hashDomain != domainSeparator) {
        throw new Error("domainhash mismatch");
    }
    return domainData;
}
exports.getDomainData = getDomainData;
//# sourceMappingURL=offchain-offers-lib.js.map